import { DOG_TYPE } from 'Tools/pets';
export const getRequiredFields = (isAddPetPurinaRequired: boolean, pet: number, viewType: string) => {
    const addParams = isAddPetPurinaRequired ? ['send_data_to_purina'] : [];
    const weight = pet === Number(DOG_TYPE) ? ['weight'] : [];
    const fields = [
        ['pet'],
        ['nick', 'birth_date', 'kind', ...weight],
        [
            'user_full_name',
            'user_email',
            'user_phone',
            'is_agreement_accepted',
            ...addParams,
        ],
    ];
    return [...(viewType === 'year2022' ? [[]] : []), ...fields];
};
/*
nick: 123321
pet: 1
kind_dog: 82
age: -1
birth_date: 01-01-2012
user_full_name: Сергей Матвейкин
user_email: s.matveykin@corp.mail.ru
is_agreement_accepted: on
send_data_to_purina: on
is_communication_agreement_accepted: on
*/
